import { merge } from "lodash-es";
import { defaultUiConfig } from "~config/sport/defaultsUi.ts";
import type { UiConfiguration } from "~types/uiConfiguration.ts";

export const handballUiConfig: UiConfiguration = merge({}, defaultUiConfig, {
  pages: {
    seasonUpsert: {
      promotionRelegationRules: {
        enabled: true,
      },
    },
  },
});
